import i18next from "i18next";

import enTranslations from "~/locales/en.json";
import frTranslations from "~/locales/fr.json";
import { useLanguageStore } from "~/stores/language";
import { Language } from "~/utils/constants";

/**
 * Initialize i18next with the translations and current language.
 *
 * NOTE: We should only initialize i18next once in the application.
 * We check if it's already initialized or initializing because this plugin
 * could be already initialized in the server side.
 */
export default defineNuxtPlugin(async () => {
  const shouldInitialize = !i18next.isInitialized && !i18next.isInitializing;

  if (shouldInitialize) {
    i18next.init({
      lng: Language.EN,
      fallbackLng: Language.EN,
      supportedLngs: [Language.EN, Language.FR],
      resources: {
        [Language.EN]: {
          translation: enTranslations,
        },
        [Language.FR]: {
          translation: frTranslations,
        },
      },
    });
  }

  /**
   * Set the current language in the store based on the route.
   *
   * This is going to check the language parameter in the URL and set the
   * language in the application based on that.
   */
  const route = useRoute();
  const languageStore = useLanguageStore();

  const language = route.params.language as Language;
  await languageStore.setCurrentLanguage(language);
});
